'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _reactIntl = require('react-intl');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SearchStatus = require('./SearchStatus.scss');

var _SearchStatus2 = _interopRequireDefault(_SearchStatus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchStatus = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(SearchStatus, _Component);

    function SearchStatus() {
        (0, _classCallCheck3.default)(this, SearchStatus);
        return (0, _possibleConstructorReturn3.default)(this, (SearchStatus.__proto__ || (0, _getPrototypeOf2.default)(SearchStatus)).apply(this, arguments));
    }

    (0, _createClass3.default)(SearchStatus, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['itemCount', 'search']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                clear = _props.clear,
                _props$itemCount = _props.itemCount,
                itemCount = _props$itemCount === undefined ? 0 : _props$itemCount,
                _props$search = _props.search,
                search = _props$search === undefined ? '' : _props$search;


            if (!search) return null;

            return (0, _jsx3.default)('div', {
                className: _SearchStatus2.default['search-status']
            }, void 0, (0, _jsx3.default)('div', {
                className: _SearchStatus2.default.match
            }, void 0, (0, _jsx3.default)('span', {
                className: _SearchStatus2.default['results-for']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'results_for',
                values: { count: '' + itemCount }
            }), (0, _jsx3.default)('span', {
                className: _SearchStatus2.default.search
            }, void 0, ' ', search), (0, _jsx3.default)('span', {
                className: _SearchStatus2.default.clear,
                onClick: clear
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'clear'
            })))), !itemCount && (0, _jsx3.default)('div', {
                className: _SearchStatus2.default['no-match']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'try_another_search'
            })));
        }
    }]);
    return SearchStatus;
}(_react.Component), _class.defaultProps = {
    itemCount: 0,
    search: ''
}, _temp);
exports.default = SearchStatus;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Pagination/SearchStatus.js
// module id = 2xKK
// module chunks = 57